import { SVGProps } from "react";
import cn from "classnames";
import styles from "./Icons.module.scss";

// https://svg2jsx.com/ - convert svg to jsx

type IconComponent = (props: SVGProps<SVGSVGElement>) => JSX.Element;

const withDefaultStyles =
  (Component: IconComponent, variant?: "12x12" | "16x16" | "20x20" | "24x24" | "28x14" | "32x32" | "40x40" | "56x56") =>
  ({ className, ...rest }: SVGProps<SVGSVGElement>) => (
    <Component className={cn({ [styles[`icon${variant}`]]: !!variant }, className)} {...rest} />
  );

export const Plus = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill={props.color ?? "#fff"}
        d="M15 8c0 .595-.482 1.077-1.077 1.077H9.077v4.846a1.076 1.076 0 1 1-2.154 0V9.077H2.077a1.077 1.077 0 1 1 0-2.154h4.846V2.077a1.077 1.077 0 1 1 2.154 0v4.846h4.846C14.52 6.923 15 7.404 15 8"
      ></path>
    </svg>
  ),
  "16x16"
);

export const FileImport = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill={props.color ?? "#000C37"}
        d="M8.192 11.474a.654.654 0 0 0 0 .928.656.656 0 0 0 .928 0l2.188-2.188a.656.656 0 0 0 0-.928L9.12 7.099a.656.656 0 1 0-.928.928L9.26 9.094H1.656a.656.656 0 0 0 0 1.312H9.26zm6.295-7.92-2.04-2.041A1.75 1.75 0 0 0 11.209 1H6.25A1.75 1.75 0 0 0 4.5 2.75v4.594a.656.656 0 1 0 1.313 0v-4.59c0-.242.195-.438.437-.438h4.375V4.5c0 .483.392.875.875.875h2.188v7.875a.44.44 0 0 1-.438.438h-7a.44.44 0 0 1-.437-.438v-1.094a.656.656 0 0 0-1.313 0v1.094c0 .966.784 1.75 1.75 1.75h7c.963 0 1.75-.787 1.75-1.75V4.791c0-.464-.184-.91-.513-1.238"
      ></path>
    </svg>
  ),
  "16x16"
);

export const FileExport = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill={props.color ?? "#000C37"}
        d="m15.805 9.286-2.222-2.187a.674.674 0 0 0-.943 0 .65.65 0 0 0 0 .928l1.084 1.067H6a.66.66 0 0 0-.667.656c0 .362.299.656.667.656h7.724l-1.084 1.067a.65.65 0 0 0 0 .928c.26.257.682.257.942 0l2.223-2.187a.65.65 0 0 0 0-.928M10 11.5a.66.66 0 0 0-.667.656v1.094a.44.44 0 0 1-.444.438h-7.11a.44.44 0 0 1-.445-.438V2.753c0-.241.198-.437.444-.437h4.444V4.5c0 .483.398.875.89.875h2.221v1.969c0 .362.299.656.667.656a.66.66 0 0 0 .667-.656V4.79c0-.464-.188-.91-.521-1.238l-2.073-2.04A1.8 1.8 0 0 0 6.816 1H1.778C.796 1 0 1.784 0 2.75v10.5C0 14.216.798 15 1.779 15h7.11c.979 0 1.779-.787 1.779-1.75v-1.094A.66.66 0 0 0 10 11.5"
      ></path>
    </svg>
  ),
  "16x16"
);

export const LoadCalcLogo = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0_2747_8944)">
        <g filter="url(#filter0_ii_2747_8944)">
          <rect width="32" height="32" fill="url(#paint0_linear_2747_8944)" rx="6.667"></rect>
        </g>
        <path
          fill="url(#paint1_linear_2747_8944)"
          fillOpacity="0.82"
          d="m16.177 10.729-4.37-2.379 3.786-1.805c.369-.176.798-.173 1.165.009l3.716 1.837z"
        ></path>
        <path fill="#fff" d="m20.364 12.991-4.195-2.261 4.303-2.34 4.195 2.256z"></path>
        <path
          fill="url(#paint2_linear_2747_8944)"
          fillOpacity="0.3"
          d="m12.013 12.99-4.385-2.388 4.183-2.253 4.373 2.388z"
        ></path>
        <path fill="url(#paint3_linear_2747_8944)" d="m16.181 15.262-4.16-2.277 4.16-2.258 4.186 2.264z"></path>
        <path fill="#fff" d="m20.34 17.512-4.154-2.263 4.16-2.258 4.185 2.263z"></path>
        <path fill="url(#paint4_linear_2747_8944)" fillOpacity="0.45" d="M7.628 15.643v-5.04l4.405 2.395v5.032z"></path>
        <path
          fill="url(#paint5_linear_2747_8944)"
          fillOpacity="0.2"
          d="m7.596 19.88.032-4.238 4.424 2.384-.038 5.032L8.3 21.066a1.33 1.33 0 0 1-.703-1.186"
        ></path>
        <path fill="url(#paint6_linear_2747_8944)" d="M12.022 18.02v-5.042l4.168 2.268-.015 5.045z"></path>
        <path fill="#62637F" d="m12.003 23.062.018-5.035 4.147 2.258v5.049z"></path>
        <path fill="#474863" d="M20.394 23.053v-5.028l-4.226 2.263v5.044z"></path>
        <path fill="#646480" d="M24.56 20.276v-5.028l-4.226 2.262v5.086z"></path>
        <path
          stroke="#000C37"
          strokeWidth="0.667"
          d="M0-.333"
          transform="matrix(.99965 -.0263 .03298 .99946 6 5.333)"
        ></path>
        <path fill="#808097" d="m16.169 20.284.017-5.035 4.168 2.243v5.076z"></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2747_8944"
          x1="0"
          x2="29.868"
          y1="1.029"
          y2="34.822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5C5A6B"></stop>
          <stop offset="0.891" stopColor="#212352"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2747_8944"
          x1="17.149"
          x2="15.382"
          y1="10.829"
          y2="4.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_2747_8944"
          x1="14.665"
          x2="5.385"
          y1="12.752"
          y2="8.574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_2747_8944"
          x1="15.428"
          x2="17.343"
          y1="14.658"
          y2="10.497"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.021" stopColor="#FFDB00"></stop>
          <stop offset="1" stopColor="#02FFDC"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_2747_8944"
          x1="10.041"
          x2="6.219"
          y1="11.115"
          y2="25.736"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_2747_8944"
          x1="10.041"
          x2="7.13"
          y1="16.154"
          y2="25.538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.68" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_2747_8944"
          x1="13.237"
          x2="12.697"
          y1="12.188"
          y2="20.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.021" stopColor="#FFDB00"></stop>
          <stop offset="1" stopColor="#FF19DA"></stop>
        </linearGradient>
        <clipPath id="clip0_2747_8944">
          <rect width="32" height="32" fill="#fff" rx="6.667"></rect>
        </clipPath>
        <filter
          id="filter0_ii_2747_8944"
          width="32"
          height="37.333"
          x="0"
          y="-2.667"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2.667"></feOffset>
          <feGaussianBlur stdDeviation="1.333"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="shape" result="effect1_innerShadow_2747_8944"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="-2.667"></feOffset>
          <feGaussianBlur stdDeviation="1.333"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.108576 0 0 0 0 0.119802 0 0 0 0 0.220833 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_innerShadow_2747_8944" result="effect2_innerShadow_2747_8944"></feBlend>
        </filter>
      </defs>
    </svg>
  ),
  "32x32"
);

export const ArrowLeftRotate = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#000C37"
        d="M1.724 1c.4 0 .724.324.724.724v3.08c1.2-2.007 3.384-3.321 5.793-3.321A6.767 6.767 0 0 1 15 8.24 6.767 6.767 0 0 1 8.241 15a6.77 6.77 0 0 1-4.326-1.565.724.724 0 1 1 .928-1.113 5.32 5.32 0 0 0 3.398 1.23 5.317 5.317 0 0 0 5.31-5.31 5.317 5.317 0 0 0-5.31-5.311c-2.007 0-3.825 1.155-4.72 2.897h3.03a.724.724 0 0 1 0 1.448H1.725A.724.724 0 0 1 1 6.552V1.724c0-.4.324-.724.724-.724"
      ></path>
    </svg>
  ),
  "16x16"
);

export const ArrowRightRotate = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12" {...props}>
      <g clipPath="url(#clip0_2830_9912)">
        <path
          fill="#000C37"
          d="M11.625 1.125V4.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 1 1 0-1.5h1.486a3.76 3.76 0 0 0-2.99-1.495A3.75 3.75 0 0 0 2.25 6a3.75 3.75 0 0 0 3.745 3.745c.818 0 1.595-.258 2.247-.748a.75.75 0 0 1 .9 1.2c-.913.686-2 1.05-3.144 1.05A5.256 5.256 0 0 1 .75 6 5.255 5.255 0 0 1 5.998.752c1.62 0 3.14.761 4.127 2.019V1.125a.75.75 0 1 1 1.5 0"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2830_9912">
          <path fill="#fff" d="M0 0h12v12H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  "12x12"
);

export const AngleDown = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#000C37"
        d="M6.404 7.485c.184 0 .368.07.508.21L10 10.781l3.088-3.087a.719.719 0 1 1 1.017 1.017l-3.596 3.595a.72.72 0 0 1-1.016 0L5.896 8.71a.719.719 0 0 1 .508-1.226"
      ></path>
    </svg>
  ),
  "20x20"
);

export const Pen = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#000C37"
        d="m14.487 2.538-1.025-1.025a1.75 1.75 0 0 0-2.475 0l-1.21 1.21-.693-.693a1.536 1.536 0 0 0-2.165 0L4.038 4.91a.656.656 0 1 0 .928.928l2.881-2.881a.22.22 0 0 1 .31 0l.693.693-5.28 5.28c-1.256 1.256-2.566 3.564-2.566 5.341a.656.656 0 0 0 .653.728c.154 0 3.035-.191 5.414-2.57l7.416-7.417a1.75 1.75 0 0 0 0-2.475m-8.346 8.965a7.67 7.67 0 0 1-3.684 2.04 7.67 7.67 0 0 1 2.04-3.684L9.75 4.606l1.645 1.644z"
      ></path>
    </svg>
  ),
  "16x16"
);

export const Check = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" fill="none" viewBox="0 0 11 9" {...props}>
      <path
        fill="#000C37"
        d="M4.033 5.411 9.123.322a1.1 1.1 0 1 1 1.555 1.556L4.81 7.744a1.1 1.1 0 0 1-.778.323c-.282 0-.563-.108-.777-.323L.322 4.811a1.1 1.1 0 1 1 1.556-1.555z"
      ></path>
    </svg>
  ),
  "12x12"
);

export const TruckFront = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56" {...props}>
      <path
        fill="#C9CFDB"
        d="m47.216 19.647-4.846-9.015a2.725 2.725 0 0 0-2.605-1.882h-10.39v11h17.772c.026-.043.043-.06.069-.103M8.75 22.5v20.625a4.126 4.126 0 0 0 4.125 4.125h30.25a4.125 4.125 0 0 0 4.125-4.125V22.5zm17.875-2.75v-11H16.238a2.74 2.74 0 0 0-2.611 1.88l-4.845 9.017.075.103z"
      ></path>
    </svg>
  ),
  "56x56"
);

export const ArrowDown = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#000C37"
        d="m14.318 9.362-3.38 3.593V3.438a.938.938 0 1 0-1.876 0v9.517l-3.38-3.593a.93.93 0 0 0-1.324-.04.937.937 0 0 0-.04 1.326l5 5.316c.354.378 1.01.378 1.364 0l5-5.316a.937.937 0 1 0-1.364-1.286"
      ></path>
    </svg>
  ),
  "20x20"
);

export const ArrowUp = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#000C37"
        d="m5.682 10.638 3.38-3.593v9.517a.938.938 0 1 0 1.876 0V7.045l3.38 3.592a.93.93 0 0 0 1.324.04.937.937 0 0 0 .04-1.324l-5-5.317c-.354-.378-1.01-.378-1.364 0l-5 5.317a.937.937 0 1 0 1.364 1.284"
      ></path>
    </svg>
  ),
  "20x20"
);

export const Trash = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 22 22" {...props}>
      <path
        fill="#000C37"
        d="M12.179 15.375h.642a.32.32 0 0 0 .228-.096.33.33 0 0 0 .094-.232V9.14a.33.33 0 0 0-.094-.232.32.32 0 0 0-.228-.097h-.642a.32.32 0 0 0-.228.097.33.33 0 0 0-.094.232v5.906c0 .087.034.17.094.232.06.061.142.096.228.096m4.392-9.187h-2.207l-.91-1.55a1.3 1.3 0 0 0-.47-.468A1.26 1.26 0 0 0 12.35 4h-2.7c-.222 0-.44.059-.634.17a1.3 1.3 0 0 0-.469.467l-.911 1.55H5.429a.42.42 0 0 0-.303.129.44.44 0 0 0-.126.309v.438c0 .116.045.227.126.309.08.082.189.128.303.128h.428v9.188c0 .348.136.681.377.928.24.246.568.384.909.384h7.714c.341 0 .668-.138.91-.384.24-.247.376-.58.376-.928V7.5h.428a.42.42 0 0 0 .303-.128.44.44 0 0 0 .126-.31v-.437a.44.44 0 0 0-.125-.31.42.42 0 0 0-.304-.128m-6.968-.796a.16.16 0 0 1 .138-.08h2.518a.16.16 0 0 1 .138.08l.468.795h-3.73zm5.254 11.296H7.143V7.5h7.714zM9.18 15.375h.642a.32.32 0 0 0 .228-.096.33.33 0 0 0 .094-.232V9.14a.33.33 0 0 0-.094-.232.32.32 0 0 0-.228-.097H9.18a.32.32 0 0 0-.228.097.33.33 0 0 0-.094.232v5.906c0 .087.034.17.094.232.06.061.142.096.228.096"
      ></path>
    </svg>
  ),
  "24x24"
);

export const Cog = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#clip0_2940_9462)">
        <path
          fill="#000C37"
          d="m14.141 8.594.995.574c.295.17.438.517.35.846a7.74 7.74 0 0 1-2.002 3.462.75.75 0 0 1-.906.12l-.993-.575q-.485.347-1.029.595v1.148a.75.75 0 0 1-.557.726 7.8 7.8 0 0 1-3.998 0 .75.75 0 0 1-.557-.726v-1.148a6 6 0 0 1-1.029-.595l-.993.574a.75.75 0 0 1-.906-.119 7.74 7.74 0 0 1-2.001-3.462.75.75 0 0 1 .349-.846l.995-.574a6 6 0 0 1 0-1.188l-.995-.574a.75.75 0 0 1-.35-.846 7.74 7.74 0 0 1 2.002-3.462.75.75 0 0 1 .906-.12l.993.575q.485-.347 1.029-.595V1.236A.75.75 0 0 1 6 .51 7.8 7.8 0 0 1 10 .51a.75.75 0 0 1 .557.725v1.148q.544.248 1.029.595l.993-.574a.75.75 0 0 1 .906.119 7.74 7.74 0 0 1 2.002 3.462.75.75 0 0 1-.35.846l-.995.574q.057.594 0 1.188m-1.646-1.97 1.37-.79a6.3 6.3 0 0 0-1.059-1.829l-1.37.791c-.999-.856-1.145-.94-2.38-1.376V1.84c-.699-.12-1.413-.12-2.113 0V3.42c-1.234.436-1.38.52-2.38 1.376l-1.37-.79a6.3 6.3 0 0 0-1.057 1.828l1.37.79c-.24 1.291-.24 1.46 0 2.752l-1.37.79a6.3 6.3 0 0 0 1.058 1.829l1.37-.791c.999.856 1.145.94 2.38 1.376v1.581c.699.12 1.413.12 2.113 0V12.58c1.234-.436 1.38-.52 2.38-1.376l1.37.79a6.3 6.3 0 0 0 1.057-1.828l-1.37-.79c.24-1.291.24-1.46 0-2.752M8 11c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m0-4.5c-.827 0-1.5.673-1.5 1.5S7.173 9.5 8 9.5 9.5 8.827 9.5 8 8.827 6.5 8 6.5"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2940_9462">
          <path fill="#fff" d="M0 16h16V0H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  "16x16"
);

export const AngleUp = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <g id="angle-up">
        <path
          fill="#000C37"
          d="M13.598 12.516a.72.72 0 0 1-.508-.21L10.002 9.22l-3.087 3.087a.719.719 0 1 1-1.017-1.017l3.596-3.595a.72.72 0 0 1 1.016 0l3.596 3.595a.72.72 0 0 1-.508 1.226"
        ></path>
      </g>
    </svg>
  ),
  "20x20"
);

export const Box = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_2940_411"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#C4C4C4" d="M0 0h16v16H0z"></path>
      </mask>
      <g fill="#000C37" mask="url(#mask0_2940_411)">
        <path
          d="m8.857 2 .857 3.429v3a.43.43 0 0 1-.428.428H6.714a.43.43 0 0 1-.428-.428v-3L7.143 2z"
          opacity="0.4"
        ></path>
        <path d="m13.965 5.429.024-.033-1.508-2.81A.86.86 0 0 0 11.667 2h-2.81l.857 3.429zm-7.68 0L7.144 2h-2.81a.86.86 0 0 0-.814.587L2.01 5.397l.024.032zm3.43.857v2.143a.43.43 0 0 1-.43.428h-2.57a.43.43 0 0 1-.43-.428V6.286H2v6.857a.857.857 0 0 0 .857.857h10.286a.857.857 0 0 0 .857-.857V6.286z"></path>
      </g>
    </svg>
  ),
  "16x16"
);

export const Barrels = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_2940_430"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#C9CFDB" d="M0 0h16v16H0z"></path>
      </mask>
      <g fill="#000C37" mask="url(#mask0_2940_430)">
        <path d="M7.697 7.027c-2.67 0-4.85-1.033-5.014-2.349h-.016v6.809C2.667 12.873 4.91 14 7.697 14s5.03-1.127 5.03-2.513V4.678h-.016c-.163 1.316-2.343 2.35-5.014 2.35"></path>
        <path
          d="M7.697 7.027c2.671 0 4.85-1.034 5.014-2.349.017-.047.017-.117.017-.164C12.728 3.128 10.483 2 7.698 2 4.91 2 2.666 3.128 2.666 4.514c0 .047 0 .117.016.164.164 1.315 2.343 2.35 5.014 2.35"
          opacity="0.4"
        ></path>
      </g>
    </svg>
  ),
  "16x16"
);

export const BigBag = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_2940_421"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#C4C4C4" d="M0 0h15.996v15.996H0z"></path>
      </mask>
      <g fill="#000C37" mask="url(#mask0_2940_421)">
        <path
          d="M8.244 4.606v-.002h1.57v-.52A2.09 2.09 0 0 1 11.906 2a2.09 2.09 0 0 1 2.09 2.086v.52h-1.045v-.521a1.04 1.04 0 0 0-1.046-1.044 1.05 1.05 0 0 0-1.046 1.042v.522h1.046zM7.752 4.606v-.002h-1.57v-.52A2.09 2.09 0 0 0 4.09 2 2.09 2.09 0 0 0 2 4.086v.52h1.045v-.521A1.04 1.04 0 0 1 4.09 3.04a1.05 1.05 0 0 1 1.047 1.042v.522H4.09z"
          opacity="0.4"
        ></path>
        <path d="M2.001 4.611 1.997 11.9a2.144 2.144 0 0 0 2.141 2.144l7.712.005a2.14 2.14 0 0 0 2.142-2.144l.004-7.287z"></path>
      </g>
    </svg>
  ),
  "16x16"
);

export const Pipes = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_2940_445"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#C4C4C4" d="M0 0h16v16H0z"></path>
      </mask>
      <g mask="url(#mask0_2940_445)">
        <path
          fill="#000C37"
          d="M4.5 4.26c-1.858 0-3.375-.665-3.489-1.512H1v7.386c0 .892 1.562 1.618 3.5 1.618S8 11.026 8 10.134V2.748H7.99C7.875 3.595 6.359 4.26 4.5 4.26"
        ></path>
        <path
          fill="#C9CFDB"
          d="M4.5 4.748c1.858 0 3.375-.822 3.489-1.869C8 2.842 8 2.785 8 2.749 8 1.644 6.438.747 4.5.747s-3.5.897-3.5 2c0 .037 0 .094.011.13.114 1.048 1.63 1.87 3.49 1.87"
        ></path>
        <path
          fill="#000C37"
          d="M4.5 4.249c1.593 0 2.893-.648 2.99-1.472.01-.03.01-.074.01-.103 0-.868-1.339-1.575-3-1.575s-3 .707-3 1.575c0 .03 0 .073.01.103.097.824 1.397 1.472 2.99 1.472M11.5 4.26c-1.858 0-3.375-.665-3.489-1.512H8v7.386c0 .892 1.562 1.618 3.5 1.618s3.5-.726 3.5-1.618V2.748h-.011c-.114.847-1.63 1.512-3.489 1.512"
        ></path>
        <path
          fill="#C9CFDB"
          d="M11.5 4.748c1.858 0 3.375-.822 3.489-1.869.011-.037.011-.094.011-.13C15 1.644 13.438.747 11.5.747s-3.5.897-3.5 2c0 .037 0 .094.011.13.114 1.048 1.63 1.87 3.49 1.87"
        ></path>
        <path
          fill="#000C37"
          d="M11.5 4.249c1.593 0 2.893-.648 2.99-1.472.01-.03.01-.074.01-.103 0-.868-1.339-1.575-3-1.575s-3 .707-3 1.575c0 .03 0 .073.01.103.097.824 1.397 1.472 2.99 1.472M8 7.76c-1.858 0-3.375-.665-3.489-1.511H4.5v7.385c0 .893 1.562 1.618 3.5 1.618s3.5-.726 3.5-1.618V6.25h-.011C11.375 7.095 9.859 7.76 8 7.76"
        ></path>
        <path
          fill="#C9CFDB"
          d="M8 8.248c1.858 0 3.375-.822 3.489-1.869.011-.037.011-.093.011-.13 0-1.104-1.562-2-3.5-2s-3.5.896-3.5 2c0 .037 0 .093.011.13.114 1.047 1.63 1.87 3.49 1.87"
        ></path>
        <path
          fill="#000C37"
          d="M8 7.749c1.593 0 2.893-.649 2.99-1.474.01-.029.01-.073.01-.103 0-.869-1.339-1.576-3-1.576s-3 .707-3 1.576c0 .03 0 .074.01.103C5.107 7.1 6.407 7.75 8 7.75"
        ></path>
      </g>
    </svg>
  ),
  "16x16"
);

export const Rolls = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_2940_463"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#C4C4C4" d="M0 0h16v16H0z"></path>
      </mask>
      <g mask="url(#mask0_2940_463)">
        <path
          fill="#000C37"
          d="M4.5 4.26c-1.858 0-3.375-.665-3.489-1.512H1v7.386c0 .892 1.562 1.618 3.5 1.618S8 11.026 8 10.134V2.748H7.99C7.875 3.595 6.359 4.26 4.5 4.26"
        ></path>
        <path
          fill="#9EA9B9"
          d="M4.5 4.748c1.858 0 3.375-.822 3.489-1.869C8 2.842 8 2.785 8 2.749 8 1.644 6.438.747 4.5.747s-3.5.897-3.5 2c0 .037 0 .094.011.13.114 1.048 1.63 1.87 3.49 1.87"
        ></path>
        <path
          fill="#000C37"
          d="M11.5 4.26c-1.858 0-3.375-.665-3.489-1.512H8v7.386c0 .892 1.562 1.618 3.5 1.618s3.5-.726 3.5-1.618V2.748h-.011c-.114.847-1.63 1.512-3.489 1.512"
        ></path>
        <path
          fill="#9EA9B9"
          d="M11.5 4.748c1.858 0 3.375-.822 3.489-1.869.011-.037.011-.094.011-.13C15 1.644 13.438.747 11.5.747s-3.5.897-3.5 2c0 .037 0 .094.011.13.114 1.048 1.63 1.87 3.49 1.87"
        ></path>
        <path
          fill="#000C37"
          d="M8 7.76c-1.858 0-3.375-.665-3.489-1.511H4.5v7.385c0 .893 1.562 1.618 3.5 1.618s3.5-.726 3.5-1.618V6.25h-.011C11.375 7.095 9.859 7.76 8 7.76"
        ></path>
        <path
          fill="#9EA9B9"
          d="M8 8.248c1.858 0 3.375-.822 3.489-1.869.011-.037.011-.093.011-.13 0-1.104-1.562-2-3.5-2s-3.5.896-3.5 2c0 .037 0 .093.011.13.114 1.047 1.63 1.87 3.49 1.87"
        ></path>
      </g>
    </svg>
  ),
  "16x16"
);

export const Sack = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_2940_438"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#C4C4C4" d="M0 0h16v16H0z"></path>
      </mask>
      <g mask="url(#mask0_2940_438)">
        <path
          fill="#000C37"
          d="M9.5 5h-3c-4.743 2.705-4.498 6.296-4.498 6.75 0 1.242 1.151 2.25 2.57 2.25h6.856c1.42 0 2.57-1.008 2.57-2.25 0-.445.22-4.06-4.498-6.75m-3-.75h3l1.111-1.667A.375.375 0 0 0 10.299 2H5.702a.375.375 0 0 0-.312.583z"
        ></path>
      </g>
    </svg>
  ),
  "16x16"
);

export const InfoCircle = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#C9CFDB"
        d="M10.188 2a8.187 8.187 0 1 0 0 16.375 8.187 8.187 0 0 0 0-16.375m0 14.738a6.557 6.557 0 0 1-6.55-6.55 6.557 6.557 0 0 1 6.55-6.55 6.557 6.557 0 0 1 6.55 6.55 6.557 6.557 0 0 1-6.55 6.55m1.364-3.821h-.546V9.915a.82.82 0 0 0-.819-.82H9.097a.819.819 0 0 0 0 1.638h.273v2.184h-.546a.819.819 0 0 0 0 1.637h2.73a.819.819 0 0 0 0-1.637m-1.364-4.913a1.092 1.092 0 1 0 0-2.183 1.092 1.092 0 0 0 0 2.183"
      ></path>
    </svg>
  ),
  "20x20"
);

export const TooltipArrow = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" fill="none" viewBox="0 0 20 13" {...props}>
      <path
        fill="#000C37"
        d="M7.642 11.879.885 5.12C-1.005 3.231.333 0 3.005 0h13.516c2.672 0 4.01 3.231 2.12 5.121l-6.756 6.758a3 3 0 0 1-4.243 0"
      ></path>
    </svg>
  ),
  "28x14"
);

export const Close = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="#000C37"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m3 3 10 10M3 13 13 3"
      ></path>
    </svg>
  ),
  "16x16"
);

export const HelpCircle = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12" {...props}>
      <circle cx="6" cy="6" r="6" fill="#C9CFDB"></circle>
      <path
        fill="#fff"
        d="M5.805 7.784c.282 0 .432-.179.454-.441 0-.039.004-.077.004-.115.023-.46.196-.662.808-1.07.661-.442 1.052-.944 1.052-1.672 0-1.158-.932-1.836-2.142-1.836-.905 0-1.664.412-1.987 1.12-.083.175-.12.354-.12.514 0 .267.161.45.443.45.225 0 .39-.126.462-.335.188-.644.609-.895 1.161-.895.661 0 1.18.384 1.18.986 0 .518-.305.796-.823 1.15-.567.392-.973.815-.973 1.451v.202c0 .29.176.491.48.491m.004 2.126a.622.622 0 1 0 .004-1.244.622.622 0 0 0-.004 1.244"
      ></path>
    </svg>
  ),
  "12x12"
);

export const Pallete = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0_3121_11429"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#C4C4C4" d="M0 0h16v16H0z"></path>
      </mask>
      <g fill="#000C37" mask="url(#mask0_3121_11429)">
        <path
          d="M13.25 3.4h-3.5a.35.35 0 0 0-.35.35v3.5a.35.35 0 0 0 .35.35h3.5a.35.35 0 0 0 .35-.35v-3.5a.35.35 0 0 0-.35-.35M7.65 2h-4.9a.35.35 0 0 0-.35.35v4.9a.35.35 0 0 0 .35.35h4.9A.35.35 0 0 0 8 7.25v-4.9A.35.35 0 0 0 7.65 2"
          opacity="0.4"
        ></path>
        <path d="M14.65 10.4a.35.35 0 0 0 .35-.35v-.7a.35.35 0 0 0-.35-.35H1.35a.35.35 0 0 0-.35.35v.7a.35.35 0 0 0 .35.35H2.4v1.4H1.35a.35.35 0 0 0-.35.35v.7a.35.35 0 0 0 .35.35h13.3a.35.35 0 0 0 .35-.35v-.7a.35.35 0 0 0-.35-.35H13.6v-1.4zM7.3 11.8H3.8v-1.4h3.5zm4.9 0H8.7v-1.4h3.5z"></path>
      </g>
    </svg>
  ),
  "16x16"
);

export const FloppyDisk = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#000C37"
        d="M8 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6.563-3.937-2.624-2.624A1.5 1.5 0 0 0 10.88 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5.119c0-.396-.157-.776-.437-1.056M5 2.5h4.5V5H5zM13.5 13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h.5v3.25c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75V2.621l2.445 2.445a.2.2 0 0 1 .055.132z"
      ></path>
    </svg>
  ),
  "16x16"
);

export const Shield = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#F52C5C"
        d="m17.369 3.855-6.55-2.73A2 2 0 0 0 10.19 1c-.18 0-.464.056-.631.126l-6.55 2.73C2.399 4.106 2 4.704 2 5.335c0 8.805 6.454 13.13 8.157 13.13 1.774 0 8.218-4.373 8.218-13.13 0-.631-.4-1.229-1.006-1.481m-4.449 7.482a.74.74 0 0 1 .27.58c0 .467-.383.818-.788.818a.82.82 0 0 1-.58-.24l-1.634-1.605-1.605 1.604a.819.819 0 1 1-1.158-1.156l1.606-1.605L7.424 8.1a.7.7 0 0 1-.239-.549.82.82 0 0 1 1.398-.579l1.604 1.606 1.605-1.605a.819.819 0 1 1 1.158 1.156l-1.606 1.605z"
      ></path>
    </svg>
  ),
  "20x20"
);

export const CheckRound = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#02BCB1"
        d="M8 0a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m3.619 6.619-4 4a.87.87 0 0 1-.619.256.87.87 0 0 1-.62-.256l-2-2a.876.876 0 0 1 1.238-1.238l1.382 1.381 3.381-3.38a.876.876 0 0 1 1.238 1.237"
      ></path>
    </svg>
  ),
  "16x16"
);
